// @ts-nocheck
import home from './home'
import news from './news'
import givingBack from './givingBack'
import history from './history'
import recruitment from './recruitment'
import alumniProfile from './alumniProfile'
import detail from './detail'
// 媒体平台
import mediaPlatform from './mediaPlatform'
// 校友服务
import alumniService from './alumniService'
// 创业校友
import setUpAlumnus from './setUpAlumnus'
// 校友总会
import alumniAssociation from './alumniAssociation'
import search from './search'
// 校友联络
import alumniContact from './alumniContact'
/** 通知公告 */
import notice from './notice'
/** 活动预告 */
import preview from './preview'
/** 校友通讯录 */
import addressBook from './addressBook'
/** 登录、注册 */
import user from './user'

export default [
  ...home,
  ...news,
  ...alumniContact,
  ...givingBack,
  ...mediaPlatform,
  ...history,
  ...addressBook,
  ...alumniService,
  ...recruitment,
  ...setUpAlumnus,
  ...alumniProfile,
  ...alumniAssociation,
  ...detail,
  ...search,
  ...notice,
  ...preview,
  ...user,
]
